<template>
  <div :class="state">
    <el-carousel height="6rem" :interval="8000" style="box-shadow: 0 6px 17px 0px rgb(0 0 0 / 25%);width: 100%">
      <el-carousel-item v-for="(item, index) in arr" :key="index" :class="'index' + index">
        <img style="object-fit: cover;height: 100%;width: 100%" :src="item.img"/>
      </el-carousel-item>
    </el-carousel>
    <el-row class="about main-row" style="margin: 1rem 0;" v-if="state==='pc'">
      <div class="wrapper">
        <el-row :gutter="48">
          <el-col :span="12" class="content desc-text animate__fadeInLeft animate__animated">
            <div class="">
              <span style="font-size: .26rem;font-weight: 600;color:#254b7c">关于我们</span>
              <span style="font-size: .18rem;margin-left: .16rem">ABOUT US</span>
            </div>
            <div style="font-size: .18rem;text-indent: 2em;margin-top: .2rem">上海力普科技服务公司成立于1992年，作为韩国LEENO在中国大陆的总代理商，是中国从事经营测试用探针及治具制造的公司。探针( SPRING CONTACT
              PROBE)是直接关系到ICT等各种测试治具质量的关键部位， 是集材料加工和表面处理领域里的高技术精密器件。 韩国LEENO工业会社自70年代起从事研究开发及制造探针， 紧跟世界电子工业发展的步伐，
              不断开发出相关产品：从PCB、ICT、SMT测试用探针，发展到目前拥有各类用途的高频，气动，开关等专用探针以及高科技的IC芯片测试座(BGA)等检测产品。 目前已行销世界二十多个国家和地区， 成为探针领域里的公认的著名品牌。
            </div>
          </el-col>
          <el-col :span="12" class="image" style="text-align: center;padding: .5rem">
            <img src="../assets/images/circle.png" class="animate__fadeInRight animate__animated"/>
          </el-col>
        </el-row>
      </div>
    </el-row>
    <el-row class="about main-row" style="margin: 1rem 0;" v-else-if="state==='mobile'">
      <div class="wrapper">
        <el-row :gutter="48">
          <el-col :span="24" class="content desc-text animate__fadeInLeft animate__animated">
            <div class="">
              <span style="font-size: .26rem;font-weight: 600;color:#254b7c">关于我们</span>
              <span style="font-size: .18rem;margin-left: .16rem">ABOUT US</span>
            </div>
            <div style="font-size: .18rem;text-indent: 2em;margin-top: .2rem">上海力普科技服务公司成立于1992年，作为韩国LEENO在中国大陆的总代理商，是中国从事经营测试用探针及治具制造的公司。探针( SPRING CONTACT
              PROBE)是直接关系到ICT等各种测试治具质量的关键部位， 是集材料加工和表面处理领域里的高技术精密器件。 韩国LEENO工业会社自70年代起从事研究开发及制造探针， 紧跟世界电子工业发展的步伐，
              不断开发出相关产品：从PCB、ICT、SMT测试用探针，发展到目前拥有各类用途的高频，气动，开关等专用探针以及高科技的IC芯片测试座(BGA)等检测产品。 目前已行销世界二十多个国家和地区， 成为探针领域里的公认的著名品牌。
            </div>
          </el-col>
        </el-row>
      </div>
    </el-row>
    <!-- 产品类别 -->
    <Function :productType="fnData"  />

    <el-row class="about main-row" style="height: auto;">
      <div class="wrapper">
        <div class="title" >
          <span>Leeno全球</span>
          <span class="line-separator"></span>
        </div>
        <p class="desc-text" style="text-align: center">
          <a target="_blank" href="http://www.leeno.com">http://www.leeno.com</a>
        </p>
        <el-row>
          <el-col :span="24" class="image">
            <img style="text-align: center;width: 100%" src="../assets/images/sell.png"/>
          </el-col>
        </el-row>
      </div>
    </el-row>
  </div>
</template>

<script>
import Function from "@/components/Function.vue";
import News from "@/components/News.vue";
import { useStore } from "vuex";
import { computed } from "vue";
import { animate } from "animate.css";
import Contact from "@/views/contact";

export default {
  name: "Home",
  components: {
    Function,
    News,
  },
  setup() {
    const arr = [
      {
        img: "http://leeno.com.cn:81/image/banner-2.jpg"
      },
      {
        img: "http://leeno.com.cn:81/image/banner-1.jpg"
      }
    ];
    const fnData = productTypes;
    const contactData = contactInfo;
    const state = computed(() => useStore().state.client);
    return {
      arr,
      fnData,
      contactData,
      state
    };
  },
  methods: {
    go(url) {
      window.open(url, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.index2 {
  background-image: linear-gradient(
          to left bottom,
          #772800,
          #efa248,
          #ffdba6,
          #efa248
  );
}

.pc{
  .container {
    display: flex;
    align-items: center;
    justify-content: space-around;
    height: 100%;
    margin: auto;
    font-size: 0;

    .left {
      img {
        height: 3.6rem;
      }
    }

    .right {
      display: flex;
      justify-content: space-around;
      flex-direction: column;
      height: 80%;

      .littleImg {
        width: 2.51rem;
      }
    }

    h2,
    h3 {
      color: #d7d7d7;
    }

    h3 {
      font-size: 0.22rem;
    }
  }
}

.mobile {
  text-align: center;
  box-sizing: border-box;

  h2 {
    font-size: .66rem;
    color: #3f3f3f;
  }

  h3 {
    font-size: .66rem;
    color: #3f3f3f;
    margin-bottom: .72rem;
  }

  .wrapper{
    text-align: left;
    width: 7rem!important;
  }
}


</style>
